// eslint-disable-next-line rover/no-namespace-import-icons
import * as Icons from '@rover/icons';
import type { SvgIcon } from '@rover/types/src/SvgIcon';

const DEFAULT_ICON = Icons.AlertInfo;

export const getIconComponent = (iconName: string | undefined | null): SvgIcon => {
  if (!iconName) return DEFAULT_ICON;

  return Icons[iconName] || DEFAULT_ICON;
};
